import { QuestionType } from './question-type.enum';
import { QuestionView } from './question-view.model';

export interface QuestionSection {
  /** The Section element's id; empty for the group that runs ahead of the first section. */
  id: string;
  title: string;
  questions: QuestionView[];
}

/** Returns nothing for a form without sections, which has nothing to tab. */
export function sectionsFor(questions: QuestionView[]): QuestionSection[] {
  const elements = questions ?? [];
  if (!elements.some(element => element.questionType === QuestionType.Section)) {
    return [];
  }

  const sections: QuestionSection[] = [];
  let sectionCount = 0;

  for (const element of elements) {
    if (element.questionType === QuestionType.Section) {
      sectionCount++;
      sections.push({
        id: element.id,
        // The builder makes the section label optional, so an unnamed tab is numbered.
        title: element.labelText?.trim() || `Section ${sectionCount}`,
        questions: []
      });
      continue;
    }

    if (sections.length === 0) {
      // Elements can sit above the first section; they get a tab of their own.
      sections.push({ id: '', title: 'General', questions: [] });
    }
    sections[sections.length - 1].questions.push(element);
  }

  return sections;
}
